import React from 'react';
import { asyncComponent } from 'react-async-component';

export default asyncComponent({
  resolve: () => import(
    /* webpackChunkName: "recommended-properties" */
    /* webpackPreload: true */
    './RecommendedProperties.js'
  ),
  LoadingComponent: () => <React.Fragment />,
  serverMode: 'defer'
});
